import { type ReactNode } from 'react';
import { ServiceArrow } from '#icons/ServiceArrow';
import { Heading } from '../../Typography/Heading';
import { spacing } from '../../../themes/stena-recycling/spacing';
import { Paragraph } from '../../Typography/Paragraph';
import { IconLinkWrapper, LinkCardTextWrapper, LinkCardWrapper } from './styles';

type LinkCardProps = {
  children: ReactNode;
  href?: string;
  title: string;
  vertical?: boolean;
  testId?: string;
  onClick?: () => Promise<void> | void;
};

export const LinkCard = ({ children, title, href, onClick, vertical, testId }: LinkCardProps) => {
  const linkClicked = async () => {
    if (onClick) {
      await onClick();
    } else if (href) {
      location.href = href;
    }
  };

  return (
    <LinkCardWrapper
      vertical={vertical}
      onClick={async () => {
        await linkClicked();
      }}
    >
      <LinkCardTextWrapper vertical={vertical}>
        <Heading as="h3" variant="sCaps" mb={vertical ? '0' : spacing.xxsmall} testId={testId}>
          {title}
        </Heading>
        {!vertical && <Paragraph variant="large">{children}</Paragraph>}
      </LinkCardTextWrapper>
      <IconLinkWrapper>
        <ServiceArrow width={spacing.mediumLow} height={spacing.mediumLow} />
      </IconLinkWrapper>
    </LinkCardWrapper>
  );
};
